const groupCPSSchools = [
    {
      "groupName": "Network 1",
      "headerName": "Albany Park",
      "address": "4929 N Sawyer Ave Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 1",
      "headerName": "Bateman",
      "address": "4220 N Richmond St Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 1",
      "headerName": "Beard",
      "address": "6445 W Strong St Chicago, Illinois 60656-4011"
    },
    {
      "groupName": "Network 1",
      "headerName": "Beaubien",
      "address": "5025 N Laramie Ave Chicago, Illinois 60630"
    },
    {
      "groupName": "Network 1",
      "headerName": "Belding",
      "address": "4257 N Tripp Ave Chicago, Illinois 60641"
    },
    {
      "groupName": "Network 1",
      "headerName": "Bridge",
      "address": "3800 N New England Ave Chicago, Illinois 60634"
    },
    {
      "groupName": "Network 1",
      "headerName": "Canty",
      "address": "3740 N Panama Ave Chicago, Illinois 60634"
    },
    {
      "groupName": "Network 1",
      "headerName": "Catalpa",
      "address": "5252 N Long Chicago, Illinois 60630-1438"
    },
    {
      "groupName": "Network 1",
      "headerName": "Chicago Academy Es",
      "address": "3400 N Austin Ave Chicago, Illinois 60634"
    },
    {
      "groupName": "Network 1",
      "headerName": "Cleveland",
      "address": "3121 W Byron St Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 1",
      "headerName": "Dever",
      "address": "3436 N Osceola Ave Chicago, Illinois 60634"
    },
    {
      "groupName": "Network 1",
      "headerName": "Dirksen",
      "address": "8601 W Foster Ave Chicago, Illinois 60656"
    },
    {
      "groupName": "Network 1",
      "headerName": "Ebinger",
      "address": "7350 W Pratt Ave Chicago, Illinois 60631"
    },
    {
      "groupName": "Network 1",
      "headerName": "Edgebrook",
      "address": "6525 N Hiawatha Ave Chicago, Illinois 60646"
    },
    {
      "groupName": "Network 1",
      "headerName": "Edison",
      "address": "4929 N Sawyer Ave Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 1",
      "headerName": "Edison Park",
      "address": "6220 N Olcott Ave Chicago, Illinois 60631"
    },
    {
      "groupName": "Network 1",
      "headerName": "Farnsworth",
      "address": "5414 N Linder Ave Chicago, Illinois 60630"
    },
    {
      "groupName": "Network 1",
      "headerName": "Garvy",
      "address": "5225 N Oak Park Ave Chicago, Illinois 60656"
    },
    {
      "groupName": "Network 1",
      "headerName": "Gray",
      "address": "3730 N Laramie Ave Chicago, Illinois 60641"
    },
    {
      "groupName": "Network 1",
      "headerName": "Henry",
      "address": "4250 N Saint Louis Ave Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 1",
      "headerName": "Hibbard",
      "address": "3244 W Ainslie St Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 1",
      "headerName": "Hitch",
      "address": "5625 N McVicker Ave Chicago, Illinois 60646"
    },
    {
      "groupName": "Network 1",
      "headerName": "Murphy",
      "address": "3539 W Grace St Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 1",
      "headerName": "North River",
      "address": "3729 W Leland Ave Chicago, Illinois 60625-5706"
    },
    {
      "groupName": "Network 1",
      "headerName": "Norwood Park",
      "address": "5900 N Nina Ave Chicago, Illinois 60631"
    },
    {
      "groupName": "Network 1",
      "headerName": "Onahan",
      "address": "6634 W Raven St Chicago, Illinois 60631"
    },
    {
      "groupName": "Network 1",
      "headerName": "Oriole Park",
      "address": "5424 N Oketo Ave Chicago, Illinois 60656"
    },
    {
      "groupName": "Network 1",
      "headerName": "Peterson",
      "address": "5510 N Christiana Ave Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 1",
      "headerName": "Portage Park",
      "address": "5330 W Berteau Ave Chicago, Illinois 60641"
    },
    {
      "groupName": "Network 1",
      "headerName": "Prussing",
      "address": "4650 N Menard Ave Chicago, Illinois 60630"
    },
    {
      "groupName": "Network 1",
      "headerName": "Reinberg",
      "address": "3425 N Major Ave Chicago, Illinois 60634"
    },
    {
      "groupName": "Network 1",
      "headerName": "Sauganash",
      "address": "6040 N Kilpatrick Ave Chicago, Illinois 60646"
    },
    {
      "groupName": "Network 1",
      "headerName": "Scammon",
      "address": "4201 W Henderson St Chicago, Illinois 60641"
    },
    {
      "groupName": "Network 1",
      "headerName": "Smyser",
      "address": "4310 N Melvina Ave Chicago, Illinois 60634"
    },
    {
      "groupName": "Network 1",
      "headerName": "Solomon",
      "address": "6206 N Hamlin Ave Chicago, Illinois 60659"
    },
    {
      "groupName": "Network 1",
      "headerName": "Stock",
      "address": "7507 W Birchwood Ave Chicago, Illinois 60631"
    },
    {
      "groupName": "Network 1",
      "headerName": "Volta",
      "address": "4950 N Avers Ave Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 1",
      "headerName": "Wildwood",
      "address": "6950 N Hiawatha Ave Chicago, Illinois 60646"
    },
    {
      "groupName": "Network 2",
      "headerName": "Brennemann",
      "address": "4251 N Clarendon Ave Chicago, Illinois 60613"
    },
    {
      "groupName": "Network 2",
      "headerName": "Chappell",
      "address": "2135 W Foster Ave Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 2",
      "headerName": "Coonley",
      "address": "4046 N Leavitt St Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 2",
      "headerName": "Courtenay",
      "address": "4420 N Beacon St Chicago, Illinois 60640"
    },
    {
      "groupName": "Network 2",
      "headerName": "Decatur",
      "address": "7030 N Sacramento Ave Chicago, Illinois 60645"
    },
    {
      "groupName": "Network 2",
      "headerName": "Disney",
      "address": "4140 N Marine Dr Chicago, Illinois 60613"
    },
    {
      "groupName": "Network 2",
      "headerName": "Field",
      "address": "7019 N Ashland Ave Chicago, Illinois 60626"
    },
    {
      "groupName": "Network 2",
      "headerName": "Gale",
      "address": "1631 W Jonquil Ter Chicago, Illinois 60626"
    },
    {
      "groupName": "Network 2",
      "headerName": "Goudy",
      "address": "5120 N Winthrop Ave Chicago, Illinois 60640"
    },
    {
      "groupName": "Network 2",
      "headerName": "Hayt",
      "address": "1518 W Granville Ave Chicago, Illinois 60660"
    },
    {
      "groupName": "Network 2",
      "headerName": "Jamieson",
      "address": "5650 N Mozart St Chicago, Illinois 60659"
    },
    {
      "groupName": "Network 2",
      "headerName": "Jordan",
      "address": "7414 N Wolcott Ave Chicago, Illinois 60626"
    },
    {
      "groupName": "Network 2",
      "headerName": "Kilmer",
      "address": "6700 N Greenview Ave Chicago, Illinois 60626"
    },
    {
      "groupName": "Network 2",
      "headerName": "Mccutcheon",
      "address": "4865 N Sheridan Rd Chicago, Illinois 60640"
    },
    {
      "groupName": "Network 2",
      "headerName": "McpHerson",
      "address": "4728 N Wolcott Ave Chicago, Illinois 60640"
    },
    {
      "groupName": "Network 2",
      "headerName": "Mosaic",
      "address": "6710 N Washtenaw Ave Chicago, Illinois 60645"
    },
    {
      "groupName": "Network 2",
      "headerName": "New Field",
      "address": "1707 W Morse Ave Chicago, Illinois 60626"
    },
    {
      "groupName": "Network 2",
      "headerName": "Ravenswood",
      "address": "4332 N Paulina St Chicago, Illinois 60613"
    },
    {
      "groupName": "Network 2",
      "headerName": "Rogers",
      "address": "7345 N Washtenaw Ave Chicago, Illinois 60645"
    },
    {
      "groupName": "Network 2",
      "headerName": "Stone",
      "address": "6239 N Leavitt St Chicago, Illinois 60659"
    },
    {
      "groupName": "Network 2",
      "headerName": "Swift",
      "address": "5900 N Winthrop Ave Chicago, Illinois 60660"
    },
    {
      "groupName": "Network 2",
      "headerName": "Waters",
      "address": "4540 N Campbell Ave Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 3",
      "headerName": "Belmont-Cragin",
      "address": "6112 W Fullerton Ave Chicago, Illinois 60639-2705"
    },
    {
      "groupName": "Network 3",
      "headerName": "Brunson",
      "address": "932 N Central Ave Chicago, Illinois 60651"
    },
    {
      "groupName": "Network 3",
      "headerName": "Burbank",
      "address": "2035 N Mobile Ave Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 3",
      "headerName": "Depriest",
      "address": "139 S Parkside Ave Chicago, Illinois 60644"
    },
    {
      "groupName": "Network 3",
      "headerName": "Ellington",
      "address": "243 N Parkside Ave Chicago, Illinois 60644"
    },
    {
      "groupName": "Network 3",
      "headerName": "Falconer",
      "address": "3020 N Lamon Ave Chicago, Illinois 60641"
    },
    {
      "groupName": "Network 3",
      "headerName": "Hanson Park",
      "address": "5411 W Fullerton Ave Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 3",
      "headerName": "Hay",
      "address": "1018 N Laramie Ave Chicago, Illinois 60651"
    },
    {
      "groupName": "Network 3",
      "headerName": "Howe",
      "address": "720 N Lorel Ave Chicago, Illinois 60644"
    },
    {
      "groupName": "Network 3",
      "headerName": "Leland",
      "address": "512 S Lavergne Ave Chicago, Illinois 60644"
    },
    {
      "groupName": "Network 3",
      "headerName": "Lewis",
      "address": "1431 N Leamington Ave Chicago, Illinois 60651"
    },
    {
      "groupName": "Network 3",
      "headerName": "Llyoyd",
      "address": "2103 N Lamon Ave Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 3",
      "headerName": "Locke J",
      "address": "2828 N Oak Park Ave Chicago, Illinois 60634"
    },
    {
      "groupName": "Network 3",
      "headerName": "Lovett",
      "address": "6333 W Bloomingdale Ave Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 3",
      "headerName": "Lyon",
      "address": "2941 N McVicker Ave Chicago, Illinois 60634"
    },
    {
      "groupName": "Network 3",
      "headerName": "McNair",
      "address": "4820 W Walton St Chicago, Illinois 60651"
    },
    {
      "groupName": "Network 3",
      "headerName": "Nash",
      "address": "4837 W Erie St Chicago, Illinois 60644-1720"
    },
    {
      "groupName": "Network 3",
      "headerName": "Northwest",
      "address": "5252 W Palmer St Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 3",
      "headerName": "Prieto",
      "address": "2231 N Central Ave Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 3",
      "headerName": "Sayre",
      "address": "1850 N Newland Ave Chicago, Illinois 60707"
    },
    {
      "groupName": "Network 3",
      "headerName": "Schubert",
      "address": "2727 N Long Ave Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 3",
      "headerName": "Spencer",
      "address": "214 N Lavergne Ave Chicago, Illinois 60644"
    },
    {
      "groupName": "Network 3",
      "headerName": "Young Es",
      "address": "1434 N Parkside Ave Chicago, Illinois 60651"
    },
    {
      "groupName": "Network 4",
      "headerName": "Alcott ES",
      "address": "2625 N Orchard St Chicago, Illinois 60614-1573"
    },
    {
      "groupName": "Network 4",
      "headerName": "Audubon",
      "address": "3500 N Hoyne Ave Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 4",
      "headerName": "Avondale-Logandale",
      "address": "3212 W George St Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 4",
      "headerName": "Barry",
      "address": "2828 N Kilbourn Ave Chicago, Illinois 60641"
    },
    {
      "groupName": "Network 4",
      "headerName": "Bell",
      "address": "3730 N Oakley Ave Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 4",
      "headerName": "Blaine",
      "address": "1420 W Grace St Chicago, Illinois 60613"
    },
    {
      "groupName": "Network 4",
      "headerName": "Brentano",
      "address": "2723 N Fairfield Ave Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 4",
      "headerName": "Burley",
      "address": "1630 W Barry Ave Chicago, Illinois 60657"
    },
    {
      "groupName": "Network 4",
      "headerName": "Chase",
      "address": "2021 N Point St Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 4",
      "headerName": "Darwin",
      "address": "3116 W Belden Ave Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 4",
      "headerName": "Fisher",
      "address": "1840 N Clark Chicago, Illinois 60614-5881"
    },
    {
      "groupName": "Network 4",
      "headerName": "Franklin",
      "address": "225 W Evergreen Ave Chicago, Illinois 60610"
    },
    {
      "groupName": "Network 4",
      "headerName": "Funston",
      "address": "2010 N Central Park Ave Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 4",
      "headerName": "Goethe",
      "address": "2236 N Rockwell St Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 4",
      "headerName": "Greeley",
      "address": "832 W Sheridan Rd Chicago, Illinois 60613"
    },
    {
      "groupName": "Network 4",
      "headerName": "Hamilton",
      "address": "1650 W Cornelia Ave Chicago, Illinois 60657"
    },
    {
      "groupName": "Network 4",
      "headerName": "Hawthorne",
      "address": "3319 N Clifton Ave Chicago, Illinois 60657"
    },
    {
      "groupName": "Network 4",
      "headerName": "Inter-American",
      "address": "851 W Waveland Ave Chicago, Illinois 60613"
    },
    {
      "groupName": "Network 4",
      "headerName": "Jahn",
      "address": "3149 N Wolcott Ave Chicago, Illinois 60657"
    },
    {
      "groupName": "Network 4",
      "headerName": "Lasalle",
      "address": "1734 N Orleans St Chicago, Illinois 60614"
    },
    {
      "groupName": "Network 4",
      "headerName": "Lincoln",
      "address": "615 W Kemper Pl Chicago, Illinois 60614"
    },
    {
      "groupName": "Network 4",
      "headerName": "Logan Square",
      "address": "3651 W Schubert Ave Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 4",
      "headerName": "Lorca",
      "address": "3231 N Springfield Ave Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 4",
      "headerName": "Manierre",
      "address": "1420 N Hudson Ave Chicago, Illinois 60610"
    },
    {
      "groupName": "Network 4",
      "headerName": "Mayer",
      "address": "2250 N Clifton Ave Chicago, Illinois 60614"
    },
    {
      "groupName": "Network 4",
      "headerName": "Mcauliffe",
      "address": "1841 N Springfield Ave Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 4",
      "headerName": "Mozart",
      "address": "2200 N Hamlin Ave Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 4",
      "headerName": "Nettelhorst",
      "address": "3252 N Broadway St Chicago, Illinois 60657"
    },
    {
      "groupName": "Network 4",
      "headerName": "Newberry",
      "address": "700 W Willow St Chicago, Illinois 60614"
    },
    {
      "groupName": "Network 4",
      "headerName": "Nixon",
      "address": "2121 N Keeler Ave Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 4",
      "headerName": "Prescott",
      "address": "1632 W Wrightwood Ave Chicago, Illinois 60614"
    },
    {
      "groupName": "Network 4",
      "headerName": "Reilly",
      "address": "3650 W School St Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 4",
      "headerName": "Skinner North",
      "address": "640 W Scott St Chicago, Illinois 60610"
    },
    {
      "groupName": "Network 4",
      "headerName": "Tubman",
      "address": "2851 N Seminary Ave Chicago, Illinois 60657"
    },
    {
      "groupName": "Network 4",
      "headerName": "Von Linne",
      "address": "3221 N Sacramento Ave Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 4",
      "headerName": "Waters",
      "address": "4540 N Campbell Ave Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 5",
      "headerName": "Beidler",
      "address": "3151 W Walnut St Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 5",
      "headerName": "Cameron",
      "address": "1234 N Monticello Ave Chicago, Illinois 60651"
    },
    {
      "groupName": "Network 5",
      "headerName": "Casals",
      "address": "3501 W Potomac Ave Chicago, Illinois 60651"
    },
    {
      "groupName": "Network 5",
      "headerName": "Cather",
      "address": "2908 W Washington Blvd Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 5",
      "headerName": "Chalmers",
      "address": "2745 W Roosevelt Rd Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 5",
      "headerName": "Chopin",
      "address": "2450 W Rice St Chicago, Illinois 60622"
    },
    {
      "groupName": "Network 5",
      "headerName": "Crown",
      "address": "2128 S Saint Louis Ave Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 5",
      "headerName": "De Diego",
      "address": "1313 N Claremont Ave Chicago, Illinois 60622"
    },
    {
      "groupName": "Network 5",
      "headerName": "Ericson",
      "address": "3600 W 5th Ave Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 5",
      "headerName": "Faraday",
      "address": "3250 W Monroe St Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 5",
      "headerName": "Gregory",
      "address": "3715 W Polk St Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 5",
      "headerName": "Hefferan",
      "address": "4409 W Wilcox St Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 5",
      "headerName": "Jensen",
      "address": "3030 W Harrison St Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 5",
      "headerName": "Johnson",
      "address": "1420 S Albany Ave Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 5",
      "headerName": "Kellman",
      "address": "3030 W Arthington St Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 5",
      "headerName": "Lawndale",
      "address": "3500 W Douglas Blvd Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 5",
      "headerName": "Lowell",
      "address": "3320 W Hirsch St Chicago, Illinois 60651"
    },
    {
      "groupName": "Network 5",
      "headerName": "Melody",
      "address": "3937 W Wilcox St Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 5",
      "headerName": "Moos",
      "address": "1711 N California Ave Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 5",
      "headerName": "Morton",
      "address": "431 N Troy St Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 5",
      "headerName": "Piccolo",
      "address": "1040 N Keeler Ave Chicago, Illinois 60651"
    },
    {
      "groupName": "Network 5",
      "headerName": "Stowe",
      "address": "3444 W Wabansia Ave Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 5",
      "headerName": "Sumner",
      "address": "4320 W 5th Ave Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 5",
      "headerName": "Tilton",
      "address": "223 N Keeler Ave Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 5",
      "headerName": "Ward L",
      "address": "646 N Lawndale Ave Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 5",
      "headerName": "Webster",
      "address": "4055 W Arthington St Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 5",
      "headerName": "West Park",
      "address": "1425 N Tripp Ave Chicago, Illinois 60651"
    },
    {
      "groupName": "Network 5",
      "headerName": "Yates",
      "address": "1839 N Richmond St Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 6",
      "headerName": "Armour",
      "address": "950 W 33rd Pl Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 6",
      "headerName": "Brown W",
      "address": "54 N Hermitage Ave Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 6",
      "headerName": "Burr",
      "address": "1621 W Wabansia Ave Chicago, Illinois 60622"
    },
    {
      "groupName": "Network 6",
      "headerName": "Chicago World Language Academy",
      "address": "1340 W Harrison St Chicago, Illinois 60607"
    },
    {
      "groupName": "Network 6",
      "headerName": "Dett",
      "address": "2131 W Monroe St Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 6",
      "headerName": "Drummond",
      "address": "1845 W Cortland St Chicago, Illinois 60622"
    },
    {
      "groupName": "Network 6",
      "headerName": "Galileo",
      "address": "820 S Carpenter St Chicago, Illinois 60607"
    },
    {
      "groupName": "Network 6",
      "headerName": "Graham Es",
      "address": "4436 S Union Ave Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 6",
      "headerName": "Haines",
      "address": "247 W 23rd Pl Chicago, Illinois 60616"
    },
    {
      "groupName": "Network 6",
      "headerName": "Healy",
      "address": "3010 S Parnell Ave Chicago, Illinois 60616"
    },
    {
      "groupName": "Network 6",
      "headerName": "Irving",
      "address": "749 S Oakley Blvd Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 6",
      "headerName": "Lozano",
      "address": "1501 N Greenview Ave Chicago, Illinois 60642"
    },
    {
      "groupName": "Network 6",
      "headerName": "Miñoso",
      "address": "3527 S Wallace St Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 6",
      "headerName": "National Teachers",
      "address": "55 W Cermak Rd Chicago, Illinois 60616"
    },
    {
      "groupName": "Network 6",
      "headerName": "Otis",
      "address": "525 N Armour St Chicago, Illinois 60642"
    },
    {
      "groupName": "Network 6",
      "headerName": "Pritzker",
      "address": "2009 W Schiller St Chicago, Illinois 60622"
    },
    {
      "groupName": "Network 6",
      "headerName": "Pulaski",
      "address": "2230 W Mclean Ave Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 6",
      "headerName": "Rudolph",
      "address": "1628 W Washington Blvd Chicago, Illinois 60612-2613"
    },
    {
      "groupName": "Network 6",
      "headerName": "Sabin",
      "address": "2216 W Hirsch St Chicago, Illinois 60622"
    },
    {
      "groupName": "Network 6",
      "headerName": "Sheridan",
      "address": "533 W 27th St Chicago, Illinois 60616"
    },
    {
      "groupName": "Network 6",
      "headerName": "Skinner",
      "address": "1260 W Adams St Chicago, Illinois 60607"
    },
    {
      "groupName": "Network 6",
      "headerName": "Smyth",
      "address": "1059 W 13th St Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 6",
      "headerName": "Suder",
      "address": "2022 W Washington Blvd Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 6",
      "headerName": "Talcott",
      "address": "1840 W Ohio St Chicago, Illinois 60622"
    },
    {
      "groupName": "Network 6",
      "headerName": "Ward J",
      "address": "2701 S Shields Ave Chicago, Illinois 60616"
    },
    {
      "groupName": "Network 7",
      "headerName": "Cooper",
      "address": "1624 W 19th St Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 7",
      "headerName": "Corkery",
      "address": "2510 S Kildare Ave Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Dvorak",
      "address": "3615 W 16th St Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Finkl",
      "address": "2332 S Western Ave Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 7",
      "headerName": "Gary",
      "address": "3740 W 31st St Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Hammond",
      "address": "2819 W 21st Pl Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Herzl",
      "address": "3711 W Douglas Blvd Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Hughes C",
      "address": "4247 W 15th St Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Kanoon",
      "address": "2233 S Kedzie Ave Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Madero",
      "address": "3202 W 28th St Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Mason",
      "address": "4217 W 18th St Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Mccormick",
      "address": "2712 S Sawyer Ave Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Orozco",
      "address": "1940 W 18th St Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 7",
      "headerName": "Ortiz De Dominguez",
      "address": "3000 S Lawndale Ave Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Penn",
      "address": "1616 S Avers Ave Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Perez",
      "address": "1241 W 19th St Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 7",
      "headerName": "Pickard",
      "address": "2301 W 21st Pl Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 7",
      "headerName": "Pilsen",
      "address": "1420 W 17th St Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 7",
      "headerName": "Ruiz",
      "address": "2410 S Leavitt St Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 7",
      "headerName": "Saucedo",
      "address": "2850 W 24th Blvd Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Telpochcalli",
      "address": "2832 W 24th Blvd Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Walsh",
      "address": "2015 S Peoria St Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 7",
      "headerName": "Whitney",
      "address": "2815 S Komensky Ave Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 7",
      "headerName": "Whittier",
      "address": "1900 W 23rd St Chicago, Illinois 60608"
    },
    {
      "groupName": "Network 7",
      "headerName": "Zapata",
      "address": "2728 S Kostner Ave Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 8",
      "headerName": "Brighton Park",
      "address": "3825 S Washtenaw Ave Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Burroughs",
      "address": "3542 S Washtenaw Ave Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Calmeca",
      "address": "3456 W 38th St Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Christopher",
      "address": "5042 S Artesian Ave Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Daley",
      "address": "5024 S Wolcott Ave Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 8",
      "headerName": "Davis N",
      "address": "3014 W 39th Pl Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Dewey",
      "address": "5415 S Union Ave Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 8",
      "headerName": "Edwards",
      "address": "4815 S Karlov Ave Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Evergreen",
      "address": "3537 S Paulina St Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 8",
      "headerName": "Fulton",
      "address": "5300 S Hermitage Ave Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 8",
      "headerName": "Greene",
      "address": "3525 S Honore St Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 8",
      "headerName": "Gunsalus",
      "address": "4420 S Sacramento Ave Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Hamline",
      "address": "4747 S Bishop St Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 8",
      "headerName": "Hedges",
      "address": "4747 S Winchester Ave Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 8",
      "headerName": "Henderson",
      "address": "5650 S Wolcott Ave Chicago, Illinois 60636"
    },
    {
      "groupName": "Network 8",
      "headerName": "Holmes",
      "address": "955 W Garfield Blvd Chicago, Illinois 60621"
    },
    {
      "groupName": "Network 8",
      "headerName": "Libby",
      "address": "5300 S Loomis Blvd Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 8",
      "headerName": "Monarcas",
      "address": "5815 S Homan Ave Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 8",
      "headerName": "Nightingale",
      "address": "5250 S Rockwell St Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Pasteur",
      "address": "5825 S Kostner Ave Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 8",
      "headerName": "Sandoval",
      "address": "5534 S Saint Louis Ave Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 8",
      "headerName": "Sawyer",
      "address": "5248 S Sawyer Ave Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Seward",
      "address": "4600 S Hermitage Ave Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 8",
      "headerName": "Sherman",
      "address": "1000 W 52nd St Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 8",
      "headerName": "Shields",
      "address": "4250 S Rockwell St Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Shields Middle",
      "address": "2611 W 48th St Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 8",
      "headerName": "Sor Juana",
      "address": "4034 W 56th Chicago, Illinois 60629-4442"
    },
    {
      "groupName": "Network 9",
      "headerName": "Ariel",
      "address": "1119 E 46th St Chicago, Illinois 60653"
    },
    {
      "groupName": "Network 9",
      "headerName": "Beasley",
      "address": "5255 S State St Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 9",
      "headerName": "Beethoven",
      "address": "25 W 47th St Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 9",
      "headerName": "Bronzeville Classical",
      "address": "8 W Root Chicago, Illinois 60609-2931"
    },
    {
      "groupName": "Network 9",
      "headerName": "Burke",
      "address": "5356 S King Dr Chicago, Illinois 60615"
    },
    {
      "groupName": "Network 9",
      "headerName": "Carnegie",
      "address": "1414 E 61st Pl Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 9",
      "headerName": "Carter",
      "address": "5740 S Michigan Ave Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 9",
      "headerName": "Doolittle",
      "address": "535 E 35th St Chicago, Illinois 60616"
    },
    {
      "groupName": "Network 9",
      "headerName": "Drake",
      "address": "2710 S Dearborn St Chicago, Illinois 60616"
    },
    {
      "groupName": "Network 9",
      "headerName": "Dulles",
      "address": "6311 S Calumet Ave Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 9",
      "headerName": "Farmer",
      "address": "4214 S St Lawrence Ave Chicago, Illinois 60653"
    },
    {
      "groupName": "Network 9",
      "headerName": "Fiske",
      "address": "6020 S Langley Ave Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 9",
      "headerName": "Harte",
      "address": "1556 E 56th St Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 9",
      "headerName": "Hendricks",
      "address": "4316 S Princeton Ave Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 9",
      "headerName": "Kozminski",
      "address": "936 E 54th St Chicago, Illinois 60615"
    },
    {
      "groupName": "Network 9",
      "headerName": "Mollison",
      "address": "4415 S Dr Martin L King Jr Dr Chicago, Illinois 60653"
    },
    {
      "groupName": "Network 9",
      "headerName": "Murray",
      "address": "5335 S Kenwood Ave Chicago, Illinois 60615"
    },
    {
      "groupName": "Network 9",
      "headerName": "Pershing",
      "address": "3200 S Calumet Ave Chicago, Illinois 60616"
    },
    {
      "groupName": "Network 9",
      "headerName": "Ray",
      "address": "5631 S Kimbark Ave Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 9",
      "headerName": "Reavis",
      "address": "834 E 50th St Chicago, Illinois 60615"
    },
    {
      "groupName": "Network 9",
      "headerName": "Robinson",
      "address": "4225 S Lake Park Ave Chicago, Illinois 60653"
    },
    {
      "groupName": "Network 9",
      "headerName": "Shoesmith",
      "address": "1330 E 50th St Chicago, Illinois 60615"
    },
    {
      "groupName": "Network 9",
      "headerName": "Till",
      "address": "6543 S Champlain Ave Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 9",
      "headerName": "Wadsworth",
      "address": "6650 S Ellis Ave Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 9",
      "headerName": "Wells ES",
      "address": "249 E 37th St Chicago, Illinois 60653"
    },
    {
      "groupName": "Network 9",
      "headerName": "Woodlawn",
      "address": "6657 S Kimbark Ave Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 9",
      "headerName": "Woodson",
      "address": "4414 S Evans Ave Chicago, Illinois 60653"
    },
    {
      "groupName": "Network 10",
      "headerName": "Ashburn",
      "address": "8300 S St Louis Ave Chicago, Illinois 60652"
    },
    {
      "groupName": "Network 10",
      "headerName": "Azuella",
      "address": "4707 W Marquette Rd Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 10",
      "headerName": "Barnard",
      "address": "10354 S Charles St Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 10",
      "headerName": "Blair",
      "address": "6751 W 63rd Pl Chicago, Illinois 60638"
    },
    {
      "groupName": "Network 10",
      "headerName": "Byrne",
      "address": "5329 S Oak Park Ave Chicago, Illinois 60638"
    },
    {
      "groupName": "Network 10",
      "headerName": "Carroll",
      "address": "2929 W 83rd St Chicago, Illinois 60652"
    },
    {
      "groupName": "Network 10",
      "headerName": "Claremont",
      "address": "2300 W 64th St Chicago, Illinois 60636"
    },
    {
      "groupName": "Network 10",
      "headerName": "Clissold",
      "address": "2350 W 110th Pl Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 10",
      "headerName": "Dawes",
      "address": "3810 W 81st Pl Chicago, Illinois 60652"
    },
    {
      "groupName": "Network 10",
      "headerName": "Dore",
      "address": "7134 W 65th St Chicago, Illinois 60638-4606"
    },
    {
      "groupName": "Network 10",
      "headerName": "Durkin Park",
      "address": "8445 S Kolin Ave Chicago, Illinois 60652"
    },
    {
      "groupName": "Network 10",
      "headerName": "Eberhart",
      "address": "3400 W 65th Pl Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 10",
      "headerName": "Esmond",
      "address": "1865 W Montvale Ave Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 10",
      "headerName": "Fairfield",
      "address": "6201 S Fairfield Ave Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 10",
      "headerName": "Grimes",
      "address": "5450 W 64th Pl Chicago, Illinois 60638"
    },
    {
      "groupName": "Network 10",
      "headerName": "Hale",
      "address": "6140 S Melvina Ave Chicago, Illinois 60638"
    },
    {
      "groupName": "Network 10",
      "headerName": "Hampton",
      "address": "3434 W 77th St Chicago, Illinois 60652"
    },
    {
      "groupName": "Network 10",
      "headerName": "Hearst",
      "address": "4640 S Lamon Ave Chicago, Illinois 60638"
    },
    {
      "groupName": "Network 10",
      "headerName": "Hurley",
      "address": "3849 W 69th Pl Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 10",
      "headerName": "Keller",
      "address": "3020 W 108th St Chicago, Illinois 60655"
    },
    {
      "groupName": "Network 10",
      "headerName": "Kellogg",
      "address": "9241 S Leavitt St Chicago, Illinois 60643-6318"
    },
    {
      "groupName": "Network 10",
      "headerName": "Marquette",
      "address": "6550 S Richmond St Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 10",
      "headerName": "Mckay",
      "address": "6901 S Fairfield Ave Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 10",
      "headerName": "Morrill",
      "address": "6011 S Rockwell St Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 10",
      "headerName": "Owen",
      "address": "8247 S Christiana Ave Chicago, Illinois 60652"
    },
    {
      "groupName": "Network 10",
      "headerName": "Richardson",
      "address": "6018 S Karlov Chicago, Illinois 60629-4929"
    },
    {
      "groupName": "Network 10",
      "headerName": "Stevenson",
      "address": "8010 S Kostner Ave Chicago, Illinois 60652"
    },
    {
      "groupName": "Network 10",
      "headerName": "Sutherland",
      "address": "10015 S Leavitt St Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 10",
      "headerName": "Tarkington",
      "address": "3330 W 71st St Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 10",
      "headerName": "Twain",
      "address": "5134 S Lotus Ave Chicago, Illinois 60638"
    },
    {
      "groupName": "Network 10",
      "headerName": "Vanderpoel",
      "address": "9510 S Prospect Ave Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 10",
      "headerName": "Vick",
      "address": "2554 W 113th St Chicago, Illinois 60655"
    },
    {
      "groupName": "Network 11",
      "headerName": "Barton",
      "address": "7650 S Wolcott Ave Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Bass",
      "address": "1140 W 66th St Chicago, Illinois 60621"
    },
    {
      "groupName": "Network 11",
      "headerName": "Bond",
      "address": "7050 S May St Chicago, Illinois 60621"
    },
    {
      "groupName": "Network 11",
      "headerName": "Cook",
      "address": "8150 S Bishop St Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Cuffe",
      "address": "8324 S Racine Ave Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Earle",
      "address": "2040 W 62nd St Chicago, Illinois 60636"
    },
    {
      "groupName": "Network 11",
      "headerName": "Evers",
      "address": "9811 S Lowe Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 11",
      "headerName": "Fort Dearborn",
      "address": "9025 S Throop St Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Foster Park",
      "address": "8530 S Wood St Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Green",
      "address": "1150 W 96th St Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 11",
      "headerName": "Gresham",
      "address": "8524 S Green St Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Harvard",
      "address": "7525 S Harvard Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Jackson M",
      "address": "917 W 88th St Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Joplin",
      "address": "7931 S Honore St Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Kershaw",
      "address": "6450 S Lowe Ave Chicago, Illinois 60621"
    },
    {
      "groupName": "Network 11",
      "headerName": "King Es",
      "address": "644 W 71st St Chicago, Illinois 60621"
    },
    {
      "groupName": "Network 11",
      "headerName": "Kipling",
      "address": "9351 S Lowe Ave Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Langford",
      "address": "6010 S Throop St Chicago, Illinois 60636"
    },
    {
      "groupName": "Network 11",
      "headerName": "Lenart",
      "address": "8101 S La Salle St Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Mays",
      "address": "6656 S Normal Blvd Chicago, Illinois 60621"
    },
    {
      "groupName": "Network 11",
      "headerName": "Nicholson",
      "address": "6006 S Peoria St Chicago, Illinois 60621"
    },
    {
      "groupName": "Network 11",
      "headerName": "Oglesby",
      "address": "7646 S Green St Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Otoole",
      "address": "6550 S Seeley Ave Chicago, Illinois 60636"
    },
    {
      "groupName": "Network 11",
      "headerName": "Parker",
      "address": "6800 S Stewart Ave Chicago, Illinois 60621"
    },
    {
      "groupName": "Network 11",
      "headerName": "Randolph",
      "address": "7316 S Hoyne Ave Chicago, Illinois 60636"
    },
    {
      "groupName": "Network 11",
      "headerName": "Ryder",
      "address": "8716 S Wallace St Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Stagg",
      "address": "7424 S Morgan St Chicago, Illinois 60621"
    },
    {
      "groupName": "Network 11",
      "headerName": "Turner-Drew",
      "address": "9300 S Princeton Ave Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 11",
      "headerName": "Wentworth",
      "address": "1340 W 71st St Chicago, Illinois 60636"
    },
    {
      "groupName": "Network 11",
      "headerName": "Westcott",
      "address": "409 W 80th St Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 12",
      "headerName": "Ashe",
      "address": "8505 S Ingleside Ave Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Avalon Park",
      "address": "8045 S Kenwood Ave Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Black",
      "address": "9101 S Euclid Ave Chicago, Illinois 60617-3749"
    },
    {
      "groupName": "Network 12",
      "headerName": "Bouchet",
      "address": "7355 S Jeffery Blvd Chicago, Illinois 60649"
    },
    {
      "groupName": "Network 12",
      "headerName": "Bradwell",
      "address": "7736 S Burnham Ave Chicago, Illinois 60649"
    },
    {
      "groupName": "Network 12",
      "headerName": "Brownell",
      "address": "6741 S Michigan Ave Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 12",
      "headerName": "Burnside",
      "address": "650 E 91st Pl Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Coles",
      "address": "8441 S Yates Blvd Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 12",
      "headerName": "Deneen",
      "address": "7240 S Wabash Ave Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Dixon",
      "address": "8306 S Saint Lawrence Ave Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Earhart",
      "address": "1710 E 93rd St Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 12",
      "headerName": "Gillespie",
      "address": "9301 S State St Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Hoyne",
      "address": "8905 S Crandon Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 12",
      "headerName": "Madison",
      "address": "7433 S Dorchester Ave Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Mann",
      "address": "8050 S Chappel Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 12",
      "headerName": "Mcdade",
      "address": "8801 S Indiana Ave Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Mireles",
      "address": "9000 S Exchange Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 12",
      "headerName": "Neil",
      "address": "8555 S Michigan Ave Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "New Sullivan",
      "address": "8331 S Mackinaw Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 12",
      "headerName": "Ninos Heroes",
      "address": "8344 S Commercial Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 12",
      "headerName": "O'Keeffe",
      "address": "6940 S Merrill Ave Chicago, Illinois 60649"
    },
    {
      "groupName": "Network 12",
      "headerName": "Park Manor",
      "address": "7037 S Rhodes Ave Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 12",
      "headerName": "Parkside",
      "address": "6938 S East End Ave Chicago, Illinois 60649"
    },
    {
      "groupName": "Network 12",
      "headerName": "Pirie",
      "address": "650 E 85th St Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Powell",
      "address": "7511 S South Shore Dr Chicago, Illinois 60649"
    },
    {
      "groupName": "Network 12",
      "headerName": "Revere",
      "address": "1010 E 72nd St Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Ruggles",
      "address": "7831 S Prairie Ave Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Schmid",
      "address": "9755 S Greenwood Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 12",
      "headerName": "South Shore Es",
      "address": "1415 E 70th St Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 12",
      "headerName": "Tanner",
      "address": "7350 S Evans Ave Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 12",
      "headerName": "Thorp J",
      "address": "8914 S Buffalo Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 12",
      "headerName": "Warren",
      "address": "9239 S Jeffery Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 12",
      "headerName": "Washington H Es",
      "address": "9130 S University Ave Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 13",
      "headerName": "Addams",
      "address": "10810 S Avenue H Chicago, Illinois 60617-6726"
    },
    {
      "groupName": "Network 13",
      "headerName": "Aldridge",
      "address": "630 E 131st St Chicago, Illinois 60827"
    },
    {
      "groupName": "Network 13",
      "headerName": "Bennett",
      "address": "10115 S Prairie Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Bright",
      "address": "10740 S Calhoun Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 13",
      "headerName": "Brown R",
      "address": "12607 S Union Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Burnham",
      "address": "9928 S Crandon Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 13",
      "headerName": "Carver G",
      "address": "901 E 133rd Pl Chicago, Illinois 60827-1427"
    },
    {
      "groupName": "Network 13",
      "headerName": "Clay",
      "address": "13231 S Burley Ave Chicago, Illinois 60633"
    },
    {
      "groupName": "Network 13",
      "headerName": "Colemon",
      "address": "1441 W 119th St Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 13",
      "headerName": "Cullen",
      "address": "10650 S Eberhart Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Curtis",
      "address": "32 E 115th St Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Dubois",
      "address": "330 E 133rd St Chicago, Illinois 60827"
    },
    {
      "groupName": "Network 13",
      "headerName": "Dunne",
      "address": "10845 S Union Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Fernwood",
      "address": "10041 S Union Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Gallistel",
      "address": "10347 S Ewing Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 13",
      "headerName": "Garvey",
      "address": "10309 S Morgan St Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 13",
      "headerName": "Grissom",
      "address": "12810 S Escanaba Ave Chicago, Illinois 60633"
    },
    {
      "groupName": "Network 13",
      "headerName": "Haley",
      "address": "11411 S Eggleston Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Higgins",
      "address": "11710 S Morgan St Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 13",
      "headerName": "Hughes L",
      "address": "240 W 104th St Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Lavizzo",
      "address": "138 W 109th St Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Marsh",
      "address": "9822 S Exchange Ave Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 13",
      "headerName": "Metcalfe",
      "address": "12339 S Normal Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Mount Vernon",
      "address": "10540 S Morgan St Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 13",
      "headerName": "Owens",
      "address": "12302 S State St Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Poe",
      "address": "10538 S Langley Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Pullman",
      "address": "11311 S Forrestville Ave Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Sadlowski",
      "address": "3930 E 105th Chicago, Illinois 60617-6335"
    },
    {
      "groupName": "Network 13",
      "headerName": "Shoop",
      "address": "11140 S Bishop St Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 13",
      "headerName": "Smith",
      "address": "744 E 103rd St Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 13",
      "headerName": "Taylor",
      "address": "9912 S Avenue H Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 13",
      "headerName": "Washington G Es",
      "address": "3611 E 114th St Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 13",
      "headerName": "Whistler",
      "address": "11533 S Ada St Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 13",
      "headerName": "White",
      "address": "1136 W 122nd St Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 14",
      "headerName": "Amundsen HS",
      "address": "5110 N Damen Ave, Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 14",
      "headerName": "Chicago Academy HS",
      "address": "3400 N Austin Ave, Chicago, Illinois 60634"
    },
    {
      "groupName": "Network 14",
      "headerName": "Devry HS",
      "address": "1900 W Lawrence Ave, Chicago, Illinois 60640-4003"
    },
    {
      "groupName": "Network 14",
      "headerName": "Disney II ES",
      "address": "3815 N Kedvale Ave, Chicago, Illinois 60641"
    },
    {
      "groupName": "Network 14",
      "headerName": "Disney II HS",
      "address": "3900 N Lawndale Ave, Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 14",
      "headerName": "Foreman HS",
      "address": "3235 N Leclaire Ave, Chicago, Illinois 60641"
    },
    {
      "groupName": "Network 14",
      "headerName": "Graham HS",
      "address": "2347 S Wabash Ave, Chicago, Illinois 60616"
    },
    {
      "groupName": "Network 14",
      "headerName": "Kelvyn Park HS",
      "address": "4343 W Wrightwood Ave, Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 14",
      "headerName": "Lake View HS",
      "address": "4015 N Ashland Ave, Chicago, Illinois 60613"
    },
    {
      "groupName": "Network 14",
      "headerName": "Lane Tech HS",
      "address": "2501 W Addison St, Chicago, Illinois 60618"
    },
    {
      "groupName": "Network 14",
      "headerName": "Lincoln Park HS",
      "address": "2001 N Orchard St, Chicago, Illinois 60614"
    },
    {
      "groupName": "Network 14",
      "headerName": "Marine Leadership at Ames HS",
      "address": "1920 N Hamlin Ave, Chicago, Illinois 60647"
    },
    {
      "groupName": "Network 14",
      "headerName": "Mather HS",
      "address": "5835 N Lincoln Ave, Chicago, Illinois 60659"
    },
    {
      "groupName": "Network 14",
      "headerName": "Northside Learning HS",
      "address": "3730 W Bryn Mawr Ave, Chicago, Illinois 60659"
    },
    {
      "groupName": "Network 14",
      "headerName": "Northside Prep HS",
      "address": "5501 N Kedzie Ave, Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 14",
      "headerName": "Roosevelt HS",
      "address": "3436 W Wilson Ave, Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 14",
      "headerName": "Schurz HS",
      "address": "3601 N Milwaukee Ave, Chicago, Illinois 60641"
    },
    {
      "groupName": "Network 14",
      "headerName": "Senn HS",
      "address": "5900 N Glenwood Ave, Chicago, Illinois 60660"
    },
    {
      "groupName": "Network 14",
      "headerName": "Steinmetz HS",
      "address": "3030 N Mobile Ave, Chicago, Illinois 60634"
    },
    {
      "groupName": "Network 14",
      "headerName": "Sullivan HS",
      "address": "6631 N Bosworth Ave, Chicago, Illinois 60626"
    },
    {
      "groupName": "Network 14",
      "headerName": "Taft HS",
      "address": "6530 W Bryn Mawr Ave, Chicago, Illinois 60631"
    },
    {
      "groupName": "Network 14",
      "headerName": "Uplift HS",
      "address": "900 W Wilson Ave, Chicago, Illinois 60640"
    },
    {
      "groupName": "Network 14",
      "headerName": "Vaughn HS",
      "address": "4355 N Linder Ave, Chicago, Illinois 60641"
    },
    {
      "groupName": "Network 14",
      "headerName": "Von Steuben HS",
      "address": "5039 N Kimball Ave, Chicago, Illinois 60625"
    },
    {
      "groupName": "Network 15",
      "headerName": "Alcott HS",
      "address": "2957 N Hoyne Ave, Chicago, Illinois 60618-8208"
    },
    {
      "groupName": "Network 15",
      "headerName": "Austin CCA HS",
      "address": "231 N Pine Ave, Chicago, Illinois 60644"
    },
    {
      "groupName": "Network 15",
      "headerName": "Clemente HS",
      "address": "1147 N Western Ave, Chicago, Illinois 60622"
    },
    {
      "groupName": "Network 15",
      "headerName": "Collins STEAM HS",
      "address": "1313 S Sacramento Dr, Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 15",
      "headerName": "Crane Medical HS",
      "address": "2245 W Jackson Blvd, Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 15",
      "headerName": "Curie HS",
      "address": "4959 S Archer Ave, Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 15",
      "headerName": "Douglass HS",
      "address": "543 N Waller Ave, Chicago, Illinois 60644"
    },
    {
      "groupName": "Network 15",
      "headerName": "Hancock HS",
      "address": "5437 W 64th Pl, Chicago, Illinois 60638-5681"
    },
    {
      "groupName": "Network 15",
      "headerName": "Infinity HS",
      "address": "3120 S Kostner Ave, Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 15",
      "headerName": "Jones HS",
      "address": "700 S State St, Chicago, Illinois 60605"
    },
    {
      "groupName": "Network 15",
      "headerName": "Juarez HS",
      "address": "1450 W Cermak Rd, Chicago, Illinois 60608-4408"
    },
    {
      "groupName": "Network 15",
      "headerName": "Manley HS",
      "address": "2935 W Polk St, Chicago, Illinois 60612"
    },
    {
      "groupName": "Network 15",
      "headerName": "Marshall HS",
      "address": "3250 W Adams St, Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 15",
      "headerName": "Multicultural Arts HS",
      "address": "3120 S Kostner Ave, Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 15",
      "headerName": "North-Grand HS",
      "address": "4338 W Wabansia Ave, Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 15",
      "headerName": "Ogden ES",
      "address": "24 W Walton St, Chicago, Illinois 60610"
    },
    {
      "groupName": "Network 15",
      "headerName": "Ogden HS",
      "address": "1250 W Erie St, Chicago, Illinois 60642"
    },
    {
      "groupName": "Network 15",
      "headerName": "Orr HS",
      "address": "730 N Pulaski Rd, Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 15",
      "headerName": "Payton HS",
      "address": "1034 N Wells St, Chicago, Illinois 60610"
    },
    {
      "groupName": "Network 15",
      "headerName": "Prosser HS",
      "address": "2148 N Long Ave, Chicago, Illinois 60639"
    },
    {
      "groupName": "Network 15",
      "headerName": "Raby HS",
      "address": "3545 W Fulton Blvd, Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 15",
      "headerName": "Social Justice HS",
      "address": "3120 S Kostner Ave, Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 15",
      "headerName": "Solorio HS",
      "address": "5400 S St Louis Ave, Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 15",
      "headerName": "Wells HS",
      "address": "936 N Ashland Ave, Chicago, Illinois 60622"
    },
    {
      "groupName": "Network 15",
      "headerName": "Westinghouse HS",
      "address": "3223 W Franklin Blvd, Chicago, Illinois 60624"
    },
    {
      "groupName": "Network 15",
      "headerName": "World Language HS",
      "address": "3120 S Kostner Ave, Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 15",
      "headerName": "Young HS",
      "address": "211 S Laflin St, Chicago, Illinois 60607"
    },
    {
      "groupName": "Network 16",
      "headerName": "Air Force HS",
      "address": "3630 S Wells St, Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 16",
      "headerName": "Bogan HS",
      "address": "3939 W 79th St, Chicago, Illinois 60652"
    },
    {
      "groupName": "Network 16",
      "headerName": "Englewood STEM HS",
      "address": "6835 S Normal, Chicago, Illinois 60621-2535"
    },
    {
      "groupName": "Network 16",
      "headerName": "Farragut HS",
      "address": "2345 S Christiana Ave, Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 16",
      "headerName": "Gage Park HS",
      "address": "5630 S Rockwell St, Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 16",
      "headerName": "Goode HS",
      "address": "7651 S Homan Ave, Chicago, Illinois 60652"
    },
    {
      "groupName": "Network 16",
      "headerName": "Hubbard HS",
      "address": "6200 S Hamlin Ave, Chicago, Illinois 60629"
    },
    {
      "groupName": "Network 16",
      "headerName": "Julian HS",
      "address": "10330 S Elizabeth St, Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 16",
      "headerName": "Kelly HS",
      "address": "4136 S California Ave, Chicago, Illinois 60632"
    },
    {
      "groupName": "Network 16",
      "headerName": "Kennedy HS",
      "address": "6325 W 56th St, Chicago, Illinois 60638"
    },
    {
      "groupName": "Network 16",
      "headerName": "Lindblom HS",
      "address": "6130 S Wolcott Ave, Chicago, Illinois 60636"
    },
    {
      "groupName": "Network 16",
      "headerName": "Morgan Park HS",
      "address": "1744 W Pryor Ave, Chicago, Illinois 60643"
    },
    {
      "groupName": "Network 16",
      "headerName": "Richards HS",
      "address": "5009 S Laflin St, Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 16",
      "headerName": "Southside HS",
      "address": "7342 S Hoyne Ave, Chicago, Illinois 60636"
    },
    {
      "groupName": "Network 16",
      "headerName": "Spry ES",
      "address": "2400 S Marshall Blvd, Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 16",
      "headerName": "Spry HS",
      "address": "2400 S Marshall Blvd, Chicago, Illinois 60623"
    },
    {
      "groupName": "Network 16",
      "headerName": "Tilden HS",
      "address": "4747 S Union Ave, Chicago, Illinois 60609"
    },
    {
      "groupName": "Network 17",
      "headerName": "Bowen HS",
      "address": "2710 E 89th St, Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 17",
      "headerName": "Bronzeville HS",
      "address": "4934 S Wabash Ave, Chicago, Illinois 60615"
    },
    {
      "groupName": "Network 17",
      "headerName": "Carver Military HS",
      "address": "13100 S Doty Ave, Chicago, Illinois 60827-1597"
    },
    {
      "groupName": "Network 17",
      "headerName": "Chicago Military HS",
      "address": "3519 S Giles Ave, Chicago, Illinois 60653"
    },
    {
      "groupName": "Network 17",
      "headerName": "Chicago Vocational HS",
      "address": "2100 E 87th St, Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 17",
      "headerName": "Corliss HS",
      "address": "821 E 103rd St, Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 17",
      "headerName": "Dunbar HS",
      "address": "3000 S King Dr, Chicago, Illinois 60616"
    },
    {
      "groupName": "Network 17",
      "headerName": "Dyett Arts HS",
      "address": "555 E 51st St, Chicago, Illinois 60615-2452"
    },
    {
      "groupName": "Network 17",
      "headerName": "Fenger HS",
      "address": "11220 S Wallace St, Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 17",
      "headerName": "Harlan HS",
      "address": "9652 S Michigan Ave, Chicago, Illinois 60628"
    },
    {
      "groupName": "Network 17",
      "headerName": "Hirsch HS",
      "address": "7740 S Ingleside Ave, Chicago, Illinois 60619"
    },
    {
      "groupName": "Network 17",
      "headerName": "Hyde Park HS",
      "address": "6220 S Stony Island Ave, Chicago, Illinois 60637"
    },
    {
      "groupName": "Network 17",
      "headerName": "Kenwood HS",
      "address": "5015 S Blackstone Ave, Chicago, Illinois 60615"
    },
    {
      "groupName": "Network 17",
      "headerName": "King HS",
      "address": "4445 S Drexel Blvd, Chicago, Illinois 60653"
    },
    {
      "groupName": "Network 17",
      "headerName": "Phillips HS",
      "address": "244 E Pershing Rd, Chicago, Illinois 60653"
    },
    {
      "groupName": "Network 17",
      "headerName": "Simeon HS",
      "address": "8147 S Vincennes Ave, Chicago, Illinois 60620"
    },
    {
      "groupName": "Network 17",
      "headerName": "South Shore Intl HS",
      "address": "1955 E 75th St, Chicago, Illinois 60649"
    },
    {
      "groupName": "Network 17",
      "headerName": "Washington HS",
      "address": "3535 E 114th St, Chicago, Illinois 60617"
    },
    {
      "groupName": "Network 17",
      "headerName": "Williams HS",
      "address": "4934 S Wabash Ave, Chicago, Illinois 60615"
    },
    {
      "groupName": "Options",
      "headerName": "Chicago Excel HS",
      "address": "1257 W 111th St, Chicago, Illinois 60643"
    },
    {
      "groupName": "Options",
      "headerName": "Excel Englewood HS",
      "address": "7141 S Morgan, Chicago, Illinois 60621-5000"
    },
    {
      "groupName": "Options",
      "headerName": "Excel South Shore HS",
      "address": "7530 S South Shore Dr, Chicago, Illinois 60649"
    },
    {
      "groupName": "Options",
      "headerName": "Excel Southwest HS",
      "address": "7050 S Washtenaw Ave, Chicago, Illinois 60629-1924"
    },
    {
      "groupName": "Options",
      "headerName": "Instituto - Justice HS",
      "address": "2570 S Blue Island Ave, Chicago, Illinois 60608-4817"
    },
    {
      "groupName": "Options",
      "headerName": "Jefferson HS",
      "address": "1100 S Hamilton Ave, Chicago, Illinois 60612"
    },
    {
      "groupName": "Options",
      "headerName": "Ombudsman - Northwest HS",
      "address": "7500 N Harlem Ave, Chicago, Illinois 60631"
    },
    {
      "groupName": "Options",
      "headerName": "Ombudsman - Roseland HS",
      "address": "10928 S Halsted St, Chicago, Illinois 60628-3128"
    },
    {
      "groupName": "Options",
      "headerName": "Ombudsman - South HS",
      "address": "6057 S Western Ave, Chicago, Illinois 60636"
    },
    {
      "groupName": "Options",
      "headerName": "Ombudsman - West HS",
      "address": "2401 W Congress Pkwy, Chicago, Illinois 60612-3534"
    },
    {
      "groupName": "Options",
      "headerName": "Pathways - Ashburn HS",
      "address": "3284 W 87th St, Chicago, Illinois 60652"
    },
    {
      "groupName": "Options",
      "headerName": "Pathways - Avondale HS",
      "address": "3100 W Belmont Ave, Chicago, Illinois 60618-5706"
    },
    {
      "groupName": "Options",
      "headerName": "Pathways - Brighton Park HS",
      "address": "3124 W 47th St, Chicago, Illinois 60632"
    },
    {
      "groupName": "Options",
      "headerName": "Pathways - Humboldt Park HS",
      "address": "2421 W Division St, Chicago, Illinois 60622-2941"
    },
    {
      "groupName": "Options",
      "headerName": "Peace and Education HS",
      "address": "4946 S Paulina St, Chicago, Illinois 60609"
    },
    {
      "groupName": "Options",
      "headerName": "SAFE Achieve ES",
      "address": "7877 S Coles Ave, Chicago, Illinois 60649-4817"
    },
    {
      "groupName": "Options",
      "headerName": "SAFE Achieve HS",
      "address": "7877 S Coles Ave, Chicago, Illinois 60649-4817"
    },
    {
      "groupName": "Options",
      "headerName": "SAFE Achieve West HS",
      "address": "230 N Kolmar, Chicago, Illinois 60624-2120"
    },
    {
      "groupName": "Options",
      "headerName": "Simpson HS",
      "address": "1321 S Paulina St, Chicago, Illinois 60608"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - ASPIRA Pantoja",
      "address": "3121 N Pulaski Rd, Chicago, Illinois 60641"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Association House",
      "address": "1116 N Kedzie Ave, Chicago, Illinois 60651-4152"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Austin Career",
      "address": "5352 W Chicago Ave, Chicago, Illinois 60651"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Campos",
      "address": "2739 W Division St, Chicago, Illinois 60622-2854"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - CCA Academy",
      "address": "1231 S Pulaski Rd, Chicago, Illinois 60623"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Chatham",
      "address": "9035 S Langley Ave, Chicago, Illinois 60619"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Innovations",
      "address": "17 N State St, Chicago, Illinois 60602"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Latino Youth",
      "address": "2001 S California Ave, Chicago, Illinois 60608"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - McKinley",
      "address": "2920 S Wabash Ave, Chicago, Illinois 60616"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Olive Harvey",
      "address": "10001 S Woodlawn Ave, Chicago, Illinois 60628"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Progressive Leadership",
      "address": "6620 S Dr Martin Luther King Jr Dr, Chicago, IL 60637-3210"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Scholastic Achievement",
      "address": "4651 W Madison St, Chicago, Illinois 60644"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Sullivan",
      "address": "8164 S South Chicago Ave, Chicago, Illinois 60617"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Truman",
      "address": "1145 W Wilson Ave, Chicago, Illinois 60640"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - West",
      "address": "4909 W Division St, Chicago, Illinois 60651"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - West Town",
      "address": "500 N Sacramento Blvd, Chicago, Illinois 60612"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Youth Connection",
      "address": "5101 S Keeler Ave, Chicago, Illinois 60632-4205"
    },
    {
      "groupName": "Options",
      "headerName": "YCCS - Youth Development",
      "address": "7836 S Union Ave, Chicago, Illinois 60620"
    },
    {
      "groupName": "Options",
      "headerName": "York HS",
      "address": "2700 S California Ave, Chicago, Illinois 60608"
    },
    {
      "groupName": "ISP",
      "headerName": "Armstrong G",
      "address": "2110 W Greenleaf Ave, Chicago, Illinois 60645"
    },
    {
      "groupName": "ISP",
      "headerName": "Back of the Yards HS",
      "address": "2111 W 47th St, Chicago, Illinois 60609"
    },
    {
      "groupName": "ISP",
      "headerName": "Brooks HS",
      "address": "250 E 111th St, Chicago, Illinois 60628"
    },
    {
      "groupName": "ISP",
      "headerName": "Budlong",
      "address": "2701 W Foster Ave, Chicago, Illinois 60625"
    },
    {
      "groupName": "ISP",
      "headerName": "Camras",
      "address": "3000 N Mango Ave, Chicago, Illinois 60634"
    },
    {
      "groupName": "ISP",
      "headerName": "Cardenas",
      "address": "2345 S Millard Ave, Chicago, Illinois 60623"
    },
    {
      "groupName": "ISP",
      "headerName": "Carson",
      "address": "5516 S Maplewood Ave, Chicago, Illinois 60629"
    },
    {
      "groupName": "ISP",
      "headerName": "Cassell",
      "address": "11314 S Spaulding Ave, Chicago, Illinois 60655"
    },
    {
      "groupName": "ISP",
      "headerName": "Chavez",
      "address": "4747 S Marshfield Ave, Chicago, Illinois 60609"
    },
    {
      "groupName": "ISP",
      "headerName": "Chicago Agriculture HS",
      "address": "3857 W 111th St, Chicago, Illinois 60655-4009"
    },
    {
      "groupName": "ISP",
      "headerName": "Clark ES",
      "address": "1045 S Monitor Ave, Chicago, Illinois 60644"
    },
    {
      "groupName": "ISP",
      "headerName": "Clark HS",
      "address": "5101 W Harrison St, Chicago, Illinois 60644"
    },
    {
      "groupName": "ISP",
      "headerName": "Clinton",
      "address": "6110 N Fairfield Ave, Chicago, Illinois 60659"
    },
    {
      "groupName": "ISP",
      "headerName": "Columbia Explorers",
      "address": "4520 S Kedzie Ave, Chicago, Illinois 60632"
    },
    {
      "groupName": "ISP",
      "headerName": "Daisy Bates",
      "address": "8546 S Cregier Ave, Chicago, Illinois 60617"
    },
    {
      "groupName": "ISP",
      "headerName": "Davis M",
      "address": "6740 S Paulina St, Chicago, Illinois 60636-3307"
    },
    {
      "groupName": "ISP",
      "headerName": "Everett",
      "address": "3419 S Bell Ave, Chicago, Illinois 60608"
    },
    {
      "groupName": "ISP",
      "headerName": "Frazier Prospective",
      "address": "4027 W Grenshaw St, Chicago, Illinois 60624"
    },
    {
      "groupName": "ISP",
      "headerName": "Ginsburg",
      "address": "1003 N Leavitt St, Chicago, Illinois 60622"
    },
    {
      "groupName": "ISP",
      "headerName": "Haugan",
      "address": "4540 N Hamlin Ave, Chicago, Illinois 60625"
    },
    {
      "groupName": "ISP",
      "headerName": "Hernandez",
      "address": "3510 W 55th St, Chicago, Illinois 60632"
    },
    {
      "groupName": "ISP",
      "headerName": "Holden",
      "address": "1104 W 31st St, Chicago, Illinois 60608"
    },
    {
      "groupName": "ISP",
      "headerName": "Jungman",
      "address": "1746 S Miller St, Chicago, Illinois 60608"
    },
    {
      "groupName": "ISP",
      "headerName": "Kinzie",
      "address": "5625 S Mobile Ave, Chicago, Illinois 60638"
    },
    {
      "groupName": "ISP",
      "headerName": "Lara",
      "address": "4619 S Wolcott Ave, Chicago, Illinois 60609"
    },
    {
      "groupName": "ISP",
      "headerName": "Lasalle II",
      "address": "1148 N Honore St, Chicago, Illinois 60622"
    },
    {
      "groupName": "ISP",
      "headerName": "Lee",
      "address": "6448 S Tripp Ave, Chicago, Illinois 60629"
    },
    {
      "groupName": "ISP",
      "headerName": "Little Village",
      "address": "2620 S Lawndale Ave, Chicago, Illinois 60623"
    },
    {
      "groupName": "ISP",
      "headerName": "McDowell",
      "address": "1419 E 89th St, Chicago, Illinois 60619"
    },
    {
      "groupName": "ISP",
      "headerName": "Mitchell",
      "address": "2233 W Ohio St, Chicago, Illinois 60612"
    },
    {
      "groupName": "ISP",
      "headerName": "Mount Greenwood",
      "address": "10841 S Homan Ave, Chicago, Illinois 60655"
    },
    {
      "groupName": "ISP",
      "headerName": "Nobel",
      "address": "4127 W Hirsch St, Chicago, Illinois 60651"
    },
    {
      "groupName": "ISP",
      "headerName": "Palmer",
      "address": "5051 N Kenneth Ave, Chicago, Illinois 60630"
    },
    {
      "groupName": "ISP",
      "headerName": "Peck",
      "address": "3826 W 58th St, Chicago, Illinois 60629"
    },
    {
      "groupName": "ISP",
      "headerName": "Peirce",
      "address": "1423 W Bryn Mawr Ave, Chicago, Illinois 60660"
    },
    {
      "groupName": "ISP",
      "headerName": "Phoenix Military HS",
      "address": "145 S Campbell Ave, Chicago, Illinois 60612"
    },
    {
      "groupName": "ISP",
      "headerName": "Plamondon",
      "address": "2642 W 15th Pl, Chicago, Illinois 60608"
    },
    {
      "groupName": "ISP",
      "headerName": "Rickover Military HS",
      "address": "5700 W Berteau Ave, Chicago, Illinois 60634-1717"
    },
    {
      "groupName": "ISP",
      "headerName": "Salazar",
      "address": "160 W Wendell St, Chicago, Illinois 60610"
    },
    {
      "groupName": "ISP",
      "headerName": "Sherwood",
      "address": "245 W 57th St, Chicago, Illinois 60621"
    },
    {
      "groupName": "ISP",
      "headerName": "South Loop",
      "address": "1601 S Dearborn St, Chicago, Illinois 60616-1225"
    },
    {
      "groupName": "ISP",
      "headerName": "STEM",
      "address": "1522 W Fillmore St, Chicago, Illinois 60607"
    },
    {
      "groupName": "ISP",
      "headerName": "Talman",
      "address": "5450 S Talman Ave, Chicago, Illinois 60632"
    },
    {
      "groupName": "ISP",
      "headerName": "Thomas",
      "address": "3625 S Hoyne Ave, Chicago, Illinois 60609"
    },
    {
      "groupName": "ISP",
      "headerName": "Thorp O",
      "address": "6024 W Warwick Ave, Chicago, Illinois 60634"
    },
    {
      "groupName": "ISP",
      "headerName": "Virtual Academy ES",
      "address": "1326 W 14th St, Chicago, Illinois 60608-1410"
    },
    {
      "groupName": "ISP",
      "headerName": "Virtual Academy HS",
      "address": "1326 W 14th St, Chicago, Illinois 60608-1410"
    },
    {
      "groupName": "ISP",
      "headerName": "Wacker",
      "address": "9746 S Morgan St, Chicago, Illinois 60643"
    },
    {
      "groupName": "ISP",
      "headerName": "West Ridge",
      "address": "6700 N Whipple St, Chicago, Illinois 60645"
    },
    {
      "groupName": "Charter Schools",
      "headerName": "ACERO - Brighton Park",
      "address": "4420 S Fairfield Ave, Chicago, Illinois 60632-1937"
    },
    {
      "groupName": "Charter Schools",
      "headerName": "ACERO - Cisneros",
      "address": "2744 W Pershing Rd, Chicago, Illinois 60632"
    },
    {
      "groupName": "Charter Schools",
      "headerName": "ACERO - Clemente",
      "address": "2050 N Natchez Ave, Chicago, Illinois 60707"
    },
    {
      "groupName": "Charter Schools",
      "headerName": "ACERO - De La Cruz",
      "address": "7416 N Ridge Blvd, Chicago, Illinois 60645-1919"
    },
    {
      "groupName": "Charter Schools",
      "headerName": "ACERO - De Las Casas",
      "address": "1641 W 16th St, Chicago, Illinois 60608"
    },
    {
      "groupName": "Charter Schools",
      "headerName": "ACERO - Fuentes",
      "address": "2845 W Barry Ave, Chicago, Illinois 60618"
    },
    {
      "groupName": "Charter Schools",
      "headerName": "ACERO - Garcia HS",
      "address": "4248 W 47th St, Chicago, Illinois 60632"
    },
    {
      "groupName": "Charter Schools",
      "headerName": "ACERO - Idar",
      "address": "5050 S Homan Ave, Chicago, Illinois 60632"
    },
    {
      "groupName": "Charter Schools",
      "headerName": "ACERO - Marquez",
      "address": "2916 W 47th St, Chicago, Illinois 60632"
    },
    {
      "groupName": "Charter Schools",
      "headerName": "ACERO - Paz",
      "address": "2651 W 23rd St, Chicago, Illinois 60608"
    },
    {
      "groupName": "Contract Schools",
      "headerName": "ChiArts HS",
      "address": "2714 W Augusta Blvd, Chicago, Illinois 60622"
    },
    {
      "groupName": "Contract Schools",
      "headerName": "Chicago Tech HS",
      "address": "1301 W 14th St, Chicago, Illinois 60608"
    },
    {
      "groupName": "Contract Schools",
      "headerName": "Plato",
      "address": "5545 W Harrison St, Chicago, Illinois 60644"
    }
  ]
  
  export default groupCPSSchools;